export const timestampToDecimal = (timestamp) => {
  const timeRegex = /^(\d{2}):(\d{2}):(\d{2})$/;
  const match = timestamp.match(timeRegex);

  if (!match) {
    return "Invalid input";
  }

  const hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  const seconds = parseInt(match[3], 10);

  if (
    isNaN(hours) || hours < 0 || hours > 23 ||
    isNaN(minutes) || minutes < 0 || minutes > 59 ||
    isNaN(seconds) || seconds < 0 || seconds > 59
  ) {
    return "Invalid input";
  }

  const decimalTime = hours + minutes / 60 + seconds / 3600;
  return decimalTime + 1;
}

export const decimalToTimestamp = (decimal) => {
  const decimalTime = decimal === 25 ? 0 : decimal - 1

  if (typeof decimalTime !== 'number' || decimalTime < 0 || decimalTime >= 24) {
    return "Invalid input";
  }

  // Split the decimal into hours and minutes
  const hours = Math.floor(decimalTime);
  const minutesDecimal = (decimalTime - hours) * 60;
  const minutes = Math.floor(minutesDecimal);
  const seconds = Math.round((minutesDecimal - minutes) * 60);

  // Ensure that hours, minutes, and seconds are in two-digit format
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}
